var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-0" },
    [
      !_vm.disabled
        ? _c("div", { staticClass: "custom-file" }, [
            _c("input", {
              staticClass: "custom-file-input form-control form-control-sm",
              attrs: {
                id: "attachments",
                type: "file",
                accept: _vm.allowedMimeTypes
              },
              on: { change: _vm.attachmentsChange }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass:
                  "custom-file-label col-form-label col-form-label-sm overflow-hidden",
                attrs: { for: "attachments" }
              },
              [_vm._v("Choose file")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.existingAttachments, function(existingAttachment) {
        return _vm.disabled
          ? _c("div", [
              _c(
                "a",
                {
                  staticClass:
                    "form-row form-control-sm text-decoration-none text-overflow-ellipsis attachment-anchor mx-0",
                  attrs: {
                    href: _vm.attachmentPath(existingAttachment.attachmentId),
                    title: existingAttachment.fileName
                  }
                },
                [_vm._v(_vm._s(existingAttachment.fileName))]
              )
            ])
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }